export default function bottomNavigation({ variables, }) {
    return {
        MuiBottomNavigation: {
            styleOverrides: {
                root: {
                    height: 48,
                    backgroundColor: variables.surface,
                    borderTop: `1px solid ${variables.border_subtle}`,
                },
            },
        },
        MuiBottomNavigationAction: {
            styleOverrides: {
                root: {
                    color: variables.text_medium,
                    "&.Mui-selected": {
                        color: variables.interactive_selected,
                    },
                },
                label: {
                    fontSize: variables.type_caption_font_size,
                    "&.Mui-selected": {
                        fontSize: variables.type_caption_font_size,
                    },
                },
            },
        },
    };
}
//# sourceMappingURL=bottomNavigation.js.map